module.exports = __webpack_public_path__ + "media/images/icons/facebook_white-b9dfefaf4dd580c2aaf77ee314d14e3c.svg";